import React, { useEffect, useState } from 'react'
import CircleLoader from '../Loader/CircleLoader/CircleLoader';

import { RootState } from '../../store';
import abilityBuild from '../../shared/CASL/appAbility';
import { useSelector } from 'react-redux';
import { IFascicolo } from '../../shared/interfaces';
import { Tree, TreeSelectionKeys } from 'primereact/tree';
import fascicoliService from '../../services/fascicoli.service';
import TreeNode from 'primereact/treenode';
import { ContextualMenu, IContextualMenuItem, ITextStyles, Text, TooltipHost } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toastRef } from '../Layout/Layout';
import { subject } from '@casl/ability';


const textStyles: Partial<ITextStyles> = {
    root: {
        color: 'inherit'
    }
}


export interface FascicoliTreeProps {
    extraCssClass?: string,
    forceTreeRefresh?: boolean,
    readOnlyMode?: boolean,
    loadingFascicoli?: boolean,
    selectedFascicoloNode?: IFascicolo
    onSelectFascicoloHandler?: (fascicolo: IFascicolo | undefined) => void,
    getProtocolliDiFascicolo?: (event) => void;
    getStoriaFascicoloHandler?: () => void;
    editFascicoloNodeHandler?: () => void;
    closeFascicoloHandler?: () => void;
    openFascicoloNodeHandler?: () => void;
    deleteFascicoloNodeHandler?: () => void;
}

type Props = FascicoliTreeProps;

const FascicoliTree: React.FunctionComponent<Props> = (props) => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);

    const [fascicoliFlatArray, setFascicoliFlatArray] = useState<IFascicolo[]>([]);
    const [fascicoliNodes, setFascicoliNodes] = useState<TreeNode[]>([]);
    const [fascicoliExpandedNodes, setFascicoliExpandedNodes] = useState<any>();
    const [selectedFascicoloKey, setSelectedFascicoloKey] = useState<TreeSelectionKeys | undefined>();

    const [loadingFascicoli, setLoadingFascicoli] = useState<boolean>(false);

    const [showContextualMenu, setShowContextualMenu] = useState(false);
    const [contextMenuItems, setContextMenuItems] = useState<IContextualMenuItem[] | undefined>([]);
    const [menuPosition, setMenuPosition] = useState<any>(undefined);



    useEffect(() => {
        setLoadingFascicoli(props.loadingFascicoli!);
    }, [props.loadingFascicoli]);

    useEffect(() => {
        getFascicoli();
    }, [currentAoo, currentUor, props.forceTreeRefresh]);

    useEffect(() => {
        updateContextMenuItems();
    }, [props.selectedFascicoloNode])


    const getFascicoli = () => {
        if (currentAoo && currentUor) {
            setLoadingFascicoli(true);
            fascicoliService.getFascicoliUorTree(currentAoo.id, currentUor.id!)
                .then(fascicoliNodes => {
                    let expandedNodes = {};
                    let fascicoliFlat: IFascicolo[] = []
                    /// Rimappo le voci dell'albero nel formato TreeNode di prime react, setto tutti i nodi come aperti
                    /// e creo l'array fascicoliFlat che utilizzo per facilitare la ricerca di un fascicolo
                    let fascicoli = remapFascicoliNodes(fascicoliNodes, expandedNodes, fascicoliFlat);

                    setFascicoliFlatArray(fascicoliFlat);
                    setFascicoliNodes(fascicoli);
                    setFascicoliExpandedNodes(expandedNodes);
                    setLoadingFascicoli(false);

                })
                .catch(error => {

                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: 'Non è stato possibile recuperare i fascicoli',
                            life: 5000
                        });
                    }

                    setLoadingFascicoli(false);

                });
        }
    }

    const remapFascicoliNodes = (fascicoliList, expandedNodes: any, fascicoliFlat: IFascicolo[], numeroPadre: string = "") => {
        let fascicoli = fascicoliList.map(fascicoloItem => {
            let numeroCurrentItem = `${numeroPadre}${fascicoloItem.numero}`
            let itemLabel = fascicoloItem.fascicoloLabel;
            let itemKey = fascicoloItem.id;
            let isSelected = itemKey === selectedFascicoloKey;

            if (isSelected && props.onSelectFascicoloHandler) {
                /// Aggiorno lo stato nel parent component 
                props.onSelectFascicoloHandler(fascicoloItem);


            }

            if (fascicoloItem.children && fascicoloItem.children.length) {
                expandedNodes[itemKey] = true;
            }

            // creo newFascicoloItem rimuovendo children e parentId da fascicoliItem
            let { children, parentId, ...newFascicoloItem } = fascicoloItem;
            fascicoliFlat.push(newFascicoloItem);

            let fascicoloItemChildren = remapFascicoliNodes(fascicoloItem.children, expandedNodes, fascicoliFlat, `${numeroCurrentItem}.`)
            return { ...fascicoloItem, key: itemKey, label: itemLabel, children: fascicoloItemChildren }

        });
        return fascicoli;
    }

    const selectFascicoloNodeHandler = (selectedKey, isFromContextMenu: boolean) => {
        if (!props.readOnlyMode) {

            if (selectedKey && selectedFascicoloKey !== selectedKey) {


                let selected = fascicoliFlatArray.find(it => (it.id === selectedKey));
                if (selected) {
                    setSelectedFascicoloKey(selectedKey);

                    if (props.onSelectFascicoloHandler) {
                        /// Aggiorno lo stato nel parent component 
                        props.onSelectFascicoloHandler(selected);
                    }
                }
            }
            // se deseleziono il fascicolo
            else if (!isFromContextMenu) {
                setSelectedFascicoloKey(undefined);

                if (props.onSelectFascicoloHandler) {
                    /// Aggiorno lo stato nel parent component 
                    props.onSelectFascicoloHandler(undefined);
                }

            }
        }
    }

    const fascicoliNodeTemplate = (node) => {

        return (
            <div className='fascicolo-node-template flex align-items-center'>
                <Text className="fascicolo-label" styles={textStyles}> {node.fascicoloLabel}</Text>
                {
                    node.dataChiusura &&
                    <TooltipHost content="Fascicolo chiuso">
                        <div style={{ marginLeft: '3px' }}>
                            <FontAwesomeIcon className="fascicolo-icon" icon={{ prefix: 'far', iconName: 'lock' }} />
                        </div>
                    </TooltipHost>
                }
                {
                    node.idPdVConservazione !== undefined &&
                    <TooltipHost content="Fascicolo archiviato">
                        <div style={{ marginLeft: '3px' }}>
                            <FontAwesomeIcon className="fascicolo-icon" icon={{ prefix: 'far', iconName: 'archive' }} />
                        </div>
                    </TooltipHost>
                }

            </div>
        )
    }

    // metodi gestione context menu 
    const onShowContextualMenu = (ev) => {
        ev.originalEvent.preventDefault();

        updateContextMenuItems();
        setShowContextualMenu(true);
        setMenuPosition(ev.originalEvent);

    };

    const updateContextMenuItems = () => {

        const menuItems: IContextualMenuItem[] = [];
        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('read', 'IFascicolo')) {
            menuItems.push({
                key: 'protocolli',
                text: 'Protocolli',
                iconProps: { iconName: 'Documentation' },
                onClick: (event) => {
                    props.getProtocolliDiFascicolo!(event);
                    onHideContextualMenu();
                }
            },
                {
                    key: 'storia',
                    text: 'Storia',
                    iconProps: { iconName: 'FullHistory' },
                    onClick: () => {
                        props.getStoriaFascicoloHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }
        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('update', 'IFascicolo') && !props.selectedFascicoloNode?.dataChiusura
            && props.selectedFascicoloNode?.idPdVConservazione === undefined) {
            menuItems.push(
                {
                    key: 'modifica',
                    text: 'Modifica',
                    iconProps: { iconName: 'Edit' },
                    onClick: () => {
                        props.editFascicoloNodeHandler!();
                        onHideContextualMenu();
                    }
                },
                {
                    key: 'chiudi',
                    text: 'Chiudi',
                    iconProps: { iconName: 'Lock' },
                    onClick: () => {
                        props.closeFascicoloHandler!();
                        onHideContextualMenu();
                    }
                },
            )
        }
        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('update', 'IFascicolo')
            && props.selectedFascicoloNode?.dataChiusura !== undefined) {
            menuItems.push(
                {
                    key: 'apri',
                    text: 'Riapri',
                    iconProps: { iconName: 'Unlock' },
                    onClick: () => {
                        props.openFascicoloNodeHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }
        if (abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))
            && abilityBuild.can('delete', 'IFascicolo')) {
            menuItems.push(
                {
                    key: 'elimina',
                    text: 'Elimina',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        props.deleteFascicoloNodeHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }

        setContextMenuItems(menuItems);
    };

    const onHideContextualMenu = () => {
        setShowContextualMenu(false);
        setContextMenuItems(undefined);
    };

    return (
        <div className={`fascicoli-tree ${props.extraCssClass}`}>
            <CircleLoader loaderClass='loader-large' loading={loadingFascicoli} />
            <div className={`position-relative my-scroll-div`}>

                {fascicoliNodes.length > 0 ?

                    <div className={`my-component-content`}>

                        <Tree
                            filter
                            filterMode="strict"
                            filterPlaceholder="Cerca un fascicolo"
                            value={fascicoliNodes}
                            expandedKeys={fascicoliExpandedNodes}
                            selectionMode="single"
                            selectionKeys={selectedFascicoloKey}
                            onSelectionChange={e => selectFascicoloNodeHandler(e.value, false)}
                            onToggle={e => setFascicoliExpandedNodes(e.value)}
                            nodeTemplate={fascicoliNodeTemplate}
                            onContextMenuSelectionChange={e => selectFascicoloNodeHandler(e.value, true)}
                            onContextMenu={e => onShowContextualMenu(e)}

                        />
                        <ContextualMenu
                            items={contextMenuItems!}
                            hidden={!showContextualMenu}
                            target={menuPosition}
                            onItemClick={onHideContextualMenu}
                            onDismiss={onHideContextualMenu}
                        />
                    </div>
                    :

                    <div style={{ marginTop: '10px' }}>
                        <Text>Nessun Fascicolo disponibile</Text>
                    </div>

                }

            </div>


        </div>



    )
}
export default FascicoliTree;
